import { CopyAllOutlined } from "@mui/icons-material";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  Box,
  Grid,
  IconButton,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { Edit, SimpleForm, TextInput, useRecordContext } from "react-admin";
import LinkToBankProducts from "../partners/LinkToBankProducts";
import OneZeroInput from "../unit/OneZeroInput";
import useNotify from "../unit/useNotify";
import CustomTable from "../unit/CustomTable";
const ShowOriginalName = () => {
  const record = useRecordContext();
  return (
    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
      {record?.sName}
    </Typography>
  );
};
const CounselorLink = ({ ...props }) => {
  const id = props.id;
  const record = useRecordContext();
  const [counselorLink, setCounselorLink] = React.useState(
    record?.share_url || ""
  );
  const { success } = useNotify();

  const handleCopy = () => {
    navigator.clipboard.writeText(counselorLink);
    success("Link copied to clipboard");
  };
  if (!counselorLink || counselorLink == "") {
    return (
      <Typography variant="body2" color="textSecondary">
        Unique URL not available. Ask Agency Admin to set it up on their portal.
      </Typography>
    );
  }
  return (
    <Box>
      <TextField
        id="outlined-basic"
        label="Counselor URL"
        variant="outlined"
        value={counselorLink}
        sx={{
          width: "100%",
          "& input.Mui-readOnly": {
            backgroundColor: "#ddd",
            borderRadius: "10px",
          },
        }}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label={"Generate URL"}
                edge="end"
                disabled={true}
              >
                <RefreshIcon color={"disabled"} />
              </IconButton>

              <IconButton
                aria-label={"Copy URL"}
                onClick={handleCopy}
                edge="end"
                sx={{ marginLeft: "20px" }}
              >
                <CopyAllOutlined color="primary" />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};
const AgencyTable = () => {
  const record = useRecordContext();
  const agencies = record?.agencyData || [];
  return (
    <div style={{ width: "810px", margin: "10px auto" }}>
      <CustomTable
        stickyHeader
        id="table-counselors-list"
        sx={{
          "& .MuiTableCell-head": {
            backgroundColor: "#edf4fb",
            height: "45px",
            maxHeight: "45px",
          },
          "& .MuiTableRow-head": {
            border: "1px solid #d5d5d5",
            backgroundColor: "#edf4fb",
            height: "45px",
            maxHeight: "45px",
          },
          "& TableCell": {
            border: "1px solid #d5d5d5",
          },

          maxWidth: "100%",
          width: "100%",
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell>First Name</TableCell>
            <TableCell>Last Name</TableCell>
            <TableCell>Email</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {agencies.map((agency: any) => (
            <TableRow>
              <TableCell>{agency.sFname}</TableCell>
              <TableCell>{agency.sLname}</TableCell>
              <TableCell>{agency.sEmail}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </CustomTable>
      {/* <thead>
          <tr>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Email</th>
          </tr>
        </thead>
        <tbody>
          {agencies.map((agency: any) => (
            <tr key={agency.id}>
              <td>{agency.sFname}</td>
              <td>{agency.sLname}</td>
              <td>{agency.sEmail}</td>
            </tr>
          ))}
        </tbody>
      </Table> */}
    </div>
  );
};
const CounselorsEdit = (props: any) => {
  const [activeTab, setActiveTab] = React.useState(0);
  const productList = props.productList;
  const curTab = props?.curTab;
  const handleChange = (newValue: number) => {
    setActiveTab(newValue);
  };
  return (
    <Edit
      {...props}
      basePath="/counselors"
      resource="counselors"
      sx={{
        borderRadius: "0px",
        marginTop: "0px",
        ".MuiPaper-root": { border: "none", borderRadiue: "none" },
        width: "100%",
        maxWidth: "100%",
        "& .MuiCard-root": {
          borderRadius: "0px",
          marginTop: "8px",
        },
      }}
      className="counselors_edit_dialog_form"
    >
      <SimpleForm toolbar={false} sx={{ pt: 0 }}>
        <Box
          sx={{
            width: "100%",
            borderBottom: 1,
            borderColor: "divider",
            mt: "0px",
            ".MuiCardContent": { paddingTop: 0 },
          }}
        >
          <ShowOriginalName />
        </Box>
        <>
          {curTab && curTab == "agency" && (
            <Box
              sx={{
                pt: 0,
                pb: 0,
              }}
            >
              <AgencyTable />
            </Box>
          )}
          {curTab && curTab == "info" && (
            <Box
              sx={{
                pt: 0,
                pb: 0,
              }}
            >
              <TextInput
                source="sName"
                variant="outlined"
                label="Organization Name"
                readOnly
                sx={{
                  "& .MuiInputBase-root": {
                    backgroundColor: "#f5f5f5",
                  },
                }}
              />
              <TextInput
                source="sContactor"
                variant="outlined"
                label="Contact Name"
                readOnly
                sx={{
                  "& .MuiInputBase-root": {
                    backgroundColor: "#f5f5f5",
                  },
                }}
              />
              <TextInput
                source="sContactEmail"
                variant="outlined"
                label="Contact Email"
                readOnly
                sx={{
                  "& .MuiInputBase-root": {
                    backgroundColor: "#f5f5f5",
                  },
                }}
              />
              <TextInput
                source="sContactPhone"
                variant="outlined"
                label="Contact Phone"
                readOnly
                sx={{
                  "& .MuiInputBase-root": {
                    backgroundColor: "#f5f5f5",
                  },
                }}
              />
              <Grid container spacing={1}>
                <Grid item xs={8}>
                  <TextInput
                    source="sAddress"
                    variant="outlined"
                    label="Street1"
                    readOnly
                    sx={{
                      "& .MuiInputBase-root": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextInput
                    source="sAddress2"
                    variant="outlined"
                    label="Street2"
                    readOnly
                    sx={{
                      "& .MuiInputBase-root": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextInput
                    source="sCity"
                    variant="outlined"
                    label="City"
                    readOnly
                    sx={{
                      "& .MuiInputBase-root": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextInput
                    source="sState"
                    variant="outlined"
                    label="State"
                    readOnly
                    sx={{
                      "& .MuiInputBase-root": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextInput
                    source="sZip"
                    variant="outlined"
                    label="Zip"
                    readOnly
                    sx={{
                      "& .MuiInputBase-root": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  />
                </Grid>
              </Grid>

              <OneZeroInput source="sStatus" label="Status" readOnly />
            </Box>
          )}
          {curTab && curTab == "linkProducts" && (
            <Box
              sx={{
                pt: 2,
                pb: 2,
              }}
            >
              <Typography variant="body1" color="error" sx={{ mb: 2 }}>
                Note: If no product is selected, the status will automatically
                be set to disabled. To enable it, please select at least one
                product.
              </Typography>
              <LinkToBankProducts productList={productList} />
            </Box>
          )}
          {curTab && curTab == "uniqueURL" && (
            <Box
              sx={{
                pt: 2,
                pb: 2,
                width: "100%",
              }}
            >
              <CounselorLink id={props.id} />
            </Box>
          )}
        </>
      </SimpleForm>
    </Edit>
  );
};

export default CounselorsEdit;
